import type { JSX } from 'react'
import type { ITextBoxProps } from '../TextBox'

import { TextBox } from '../TextBox'
import { Colors, TextBoxTypes } from '../TextBox.h'

export interface ITextBoxMaxLine2Footnote4Props extends ITextBoxProps {}

export const TextBoxMaxLine2Footnote4 = ({
  title = '',
  color = Colors.TEXT_ICON_PRIMARY,
  font = TextBoxTypes.Footnote4,
  maxLines = 2,
  ...rest
}: ITextBoxMaxLine2Footnote4Props): JSX.Element => (
  <TextBox
    title={title}
    color={color}
    font={font}
    maxLines={maxLines}
    {...rest}
  />
)
